import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import Expando, {
  Content,
  InteractiveLabel,
  LabelTitle,
  StatusIndicator,
} from './Boneyard/Expando/Expando';

export const propTypes = {
  /** Determines the open or closed status of the Expando */
  open: PropTypes.bool,
  /** Apply padding around child content */
  padContent: PropTypes.bool,
  /**
   * Hides the label.
   * Useful when needing to control the expanded state from elsewhere (in this case remember to set the `contentID`)
   */
  hideLabel: PropTypes.bool,
};

export const defaultProps = {
  open: false,
  padContent: false,
  hideLabel: false,
};

/** @visibleName Modern Expando */
const RebrandedExpando = styled(Expando)`
  ${Content} {
    padding-top: 5px;
    padding-bottom: 10px;

    ${props =>
      props.padContent &&
      css`
        padding: 0 ${props.theme.spacing(2)} ${props.theme.spacing(2)};
      `};

    ${props =>
      props.padContent &&
      props.hideLabel &&
      css`
        padding-top: ${props.theme.spacing(2)};
      `};

    ${props =>
      props.noPadding &&
      css`
        padding: 0;
      `}
  }

  ${InteractiveLabel} {
    display: flex;
    flex: 1;
    flex-direction: row;
    justify-content: space-between;
    font-weight: 500;
    text-align: center;
    align-items: center;
    line-height: 1.875rem;
    background-color: #fff;
    padding: ${props => props.theme.spacing(2)} 0;
    border-top: 2px solid ${props => props.theme.colors.hob.expando.border};
  }

  ${StatusIndicator} {
    display: flex;
    align-items: center;
  }

  ${LabelTitle} {
    flex: 1;
    padding-right: ${props => props.theme.spacing(2)};
    text-align: left;
    ${props =>
      props.labelTitleAlignment &&
      css`
        text-align: ${props.labelTitleAlignment};
      `};
    color: ${props => props.theme.colors.common.dark};
  }
`;

RebrandedExpando.propTypes = propTypes;
RebrandedExpando.defaultProps = defaultProps;

/** @component */
export default RebrandedExpando;
